import React, { useEffect, useState } from "react";
import styled from "styled-components";
import logo from "../../assets/logo.png";
import throttle from "lodash.throttle";
import Nav from "./Nav";

const Holder = styled.header`
  pointer-events: none;
  position: absolute;
  z-index: 600;
  top: 0;
  left: 0;
  bottom: 0;

  a,
  button {
    pointer-events: auto;
  }

  .nav {
    transform: translateY(0);
    transition: transform 1s ease-in-out;
  }

  &.hide {
    .nav {
      @media (${(props) => props.theme.breakpoints.md}) {
        transform: translateY(-100px);
      }
    }
  }
`;

const Logo = styled.div`
  position: fixed;
  z-index: 600;
  top: 24px;
  left: 16px;
  @media (${(props) => props.theme.breakpoints.md}) {
    width: 100%;
    left: 28px;
    top: 28px;
  }

  a {
    display: block;
    margin: 0;
    @media (${(props) => props.theme.breakpoints.md}) {
      width: 194px;
    }

    img {
      width: auto;
      height: 17px;
      display: block;
      @media (${(props) => props.theme.breakpoints.md}) {
        width: 194px;
        height: auto;
      }
    }
  }
`;

function Header({isProjects = false}) {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const onScroll = () => {
      let st = window.pageYOffset || document.documentElement.scrollTop;
      if (!isProjects && st > 100) {
        setShow(false);
      } else {
        setShow(true);
      }
    };

    const throttledCount = throttle(onScroll, 100);
    window.addEventListener("scroll", throttledCount);
    return () => window.removeEventListener("scroll", throttledCount);
  });

  return (
    <Holder className={show ? "show" : "hide"} style={{
      zIndex: isProjects ? 800000 : 600
    }}>
      <Logo>
        <a className="logo" href="/">
          <img src={logo} alt="Studio Libro" />
        </a>
      </Logo>
      <Nav className="nav" />
    </Holder>
  );
}

export default Header;
